const siteText = {
  zh: {
    home: {
      nav: ["网站首页", "关于展佳", "企业视频", "产品中心", "新闻公告", "联系我们"],
      languageLabel: "EN",
    },
    shared: {
      topTitles: {
        about: "关于我们",
        video: "企业视频",
        product: "产品中心",
        news: "新闻公告",
        relation: "联系我们",
      },
      tabView: ["公司简介", "联系我们", "新闻公告"],
    },
    formWork: {
      heroTitle: "按需定制 精度控制",
      heroSubtitle: "通过三次元坐标检测/模架开合顺畅/使用寿命提高50%",
      introLines: [
        "公司自2008年4月份创建以来",
        "依靠出色的设计人员和模具技工做出高品质的产品，赢得广大客户的好评。",
        "本公司已经通过ISO9001质量体系认证，规范的管理使我公司的发展更快迈入",
        "正轨。我公司以合理的价位，先进的管理，优良的品质来赢得客户的信赖。",
      ],
      sectionTitle: "展佳模架",
      sectionSubtitle: "为各类模具提供专业模架产品",
      process: ["客供图档", "拆图编程", "材料定制", "按图加工", "模架组装", "合格出厂"],
      craftsmanshipTitle: "用匠心",
      craftsmanshipHighlight: "造精品",
      craftsmanshipLines: [
        "源于对微细加工行业的热爱和坚守，展佳自创立以来，始",
        "终秉承品质可靠、客户至上、永续创新、实现双赢的经营",
        "理念，引进多台高精密自动化加工设备，不断提高产品质",
        "量和服务质量，为业内提供优良的产品和服务，是我们共",
        "同的理想，也是我们砥砺前行的伟大使命！",
      ],
      categoryTitle: "产品分类",
      categoryItems: ["塑胶模模架", "压铸模模架"],
      productCards: [
        "塑胶模、化妆品模模架",
        "压铸模模架",
        "塑胶模",
        "压铸模",
      ],
      viewMore: "VIEW MORE",
      strengthTitle: "展佳 · 实力定制驭领业内",
      strengthSubtitle: "以高品质模架助推中国制造业高质发展",
      strengthYearSuffix: "年",
      strengthLines: [
        "专注模架定制15年，量身定制工艺解决方案及成套设备，全面覆盖汽车、家电、化妆品等塑",
        "胶、压铸模架、双色模架应用领域，备受信赖。",
      ],
      serviceTitle: "服务特色",
      serviceSubtitle: "Service Features",
      serviceItems: [
        "专家指挥：提供模架专业知识咨询和相关工业解决方案。",
        "一站式采购：最大限度地节约采购成本和时间。",
        "质量保证：拥有ISO质量认证。",
        "“共发展，同盈利”理念的忠实践行者。",
      ],
    },
    regard: {
      title: "公司简介",
      subtitle: "COMPANY PROFILE",
      slogan: "厚德诚信 和谐共赢",
      profileLines: [
        "本公司主要承接精密化妆品模、塑胶模、汽车模、压铸模等非标模具模架制作。公司自2008年4月份创建以来依靠出色的设计人员和模具技工做出高品质的产品，赢得广大客户的好评。",
        "本公司拥有20台CNC数控加工中心、龙门铣及数台大型磨床、钻床、铣床等机床。现模架月产量平均为200套每月，以非标模架为主。具备三次元、电子高度规、规格齐全的各式内外径分离卡、千分尺等精密测量仪器为主要检测设备。来自日本、台湾的生产机器和精密检测仪器是我公司精密加工的保证。",
        "本公司自2017年初实施绩效改革，现场各生产部门实行承包激励制度，现产能显著提高，比历史同期上涨40%，我司计划进一步提高产线产能，增加高精度的机器设备，以满足不同行业客户需求。公司长期发展规划前景广阔，我司定位为加工精度要求较高的压铸模具、塑胶模具、高精度化妆品模具、汽车、家电模具及产品客户为主要客户群，公司内部实行更加正轨的管理，并改善生产环境及提高员工技术，从而达到公司再上一个台阶的目标。",
      ],
      stats: [
        { value: "2008", unit: "年", text: "公司创始于2008年" },
        { value: "3000", unit: "余平方", text: "厂房/办公楼和员工宿舍达3千多平方米" },
        { value: "200", unit: "套每月", text: "模架月产量平均为200套每月" },
      ],
      purposeTitle: "企业宗旨",
      purposeSubtitle: "CORPORATE PURPOSES",
      purposes: [
        { title: "品质至上", text: "创造卓越的模架，以卓越品质引领行业，满足客户需求，持续创新进取。" },
        { title: "客户至上", text: "以客户为中心，倾听反馈，定制个性解决方案，携手共创共赢未来。" },
        { title: "团结一致", text: "强调团队协作，激发员工潜力，共同成长，共建和谐、高效的工作家园。" },
        { title: "创新驱动", text: "创新引领，模架技术的不竭动力，持续创造行业新标杆。" },
      ],
      spiritTitle: "企业精神/核心价值观",
      spiritSubtitle: "CORPORATE SPIRIT/CORE VALUES",
      spirits: [
        { short: ["坚韧", "尽责"], text: "我们以坚韧不拔的决心和责任心铸就每一件模架，无论面对何种困难，我们始终如一地对客户和品质负责。坚韧尽责，是我们持续奋斗和精益求精的动力，也是客户信赖的根本。" },
        { short: ["专业", "专注"], text: "在专业领域中，我们保持专注，不断提升技术水平，精益求精。我们拥有一支充满热情和专业精神的团队，致力于为客户提供高水平、专业化的模架解决方案，以满足不同领域的需求。" },
        { short: ["创新", "进取"], text: "创新是我们不断进取的灵魂。我们鼓励员工积极提出新思路，投身于不断创新的工作氛围中。我们相信通过创新，可以超越行业标准，为客户提供更具前瞻性和竞争力的模架产品。" },
        { short: ["效率", "规范"], text: "我们以高效率和规范管理为核心，不断追求生产和管理的卓越。通过精密计划和严格的质量控制，我们确保交付高品质模架的同时，提升生产效率，实现对客户的更快响应。" },
        { short: ["开放", "协同"], text: "我们倡导开放心态和协同合作，与客户、合作伙伴和员工共同成长。开放的文化促使我们积极汲取外部智慧，与各方紧密合作，以共同推动模具工业的创新和进步。开放协同，创造共赢未来。" },
      ],
    },
    video: {
      title: "视频中心",
      subtitle: "VIDEO CENTER",
      slogan: "厚德诚信 和谐共赢",
    },
    product: {
      title: "产品中心",
      subtitle: "PRODUCT CENTER",
      sections: [
        { title: "压铸模", subtitle: "Die Casting Mold" },
        { title: "塑胶模", subtitle: "Plastic Mold" },
      ],
    },
    news: {
      title: "新闻公告",
      subtitle: "NEWS ANNOUNCEMENT",
      items: [
        {
          day: "26",
          date: "2023.10",
          title: "2023年10月26为期三天的俄罗斯国际机床展圆满结束，俄罗斯客户络绎不绝，收获满满！",
          summary: "展佳模架展位内，俄罗斯客户咨询并探讨了模架制造工艺及适用产品行业，与我司销售人员及技术人员深入交流。",
        },
        {
          day: "18",
          date: "2023.11",
          title: "2023年11月18日越南胡志明市国际工业展会圆满结束，现场交流热烈，成果丰硕！",
          summary: "展佳模架在展会现场与越南及海外客户深入探讨模架制造工艺、行业应用及后续合作方向。",
        },
      ],
      detailButton: "查看详情",
    },
    newsDetails: {
      title: "展佳模具-俄罗斯国际机床展圆满结束",
      outline: "【概要】",
      date: "2023年10月26日",
      introLines: [
        "为期三天的俄罗斯国际机床展圆满结束",
        "展佳模具参展俄罗斯国际机床展",
        "俄罗斯客户络绎不绝，收获满满！",
      ],
      section1Title: "展佳模架参展展会现场：",
      paragraph1: "展佳模架展位内，俄罗斯客户咨询并探讨了模架制造工艺及适用产品行业，与我司销售人员及技术人员深入交流。并探讨了模架定制流程及出口的可能性，为今后的合作做好铺垫工作。",
      paragraph2: "俄罗斯客户首先非常认可展佳模架所在的苏州市的地理优势及经济优势，其次认可展佳模架的产品质量及工艺水平，期待打开展佳模架的国际市场。",
      section2Title: "参展亚克力样品：",
      section3Title: "展位一角：",
    },
    newsDetails2: {
      title: "展佳模具-越南胡志明市国际工业展会圆满结束",
      outline: "【概要】",
      date: "2023年11月18日",
      introLines: [
        "为期三天的越南胡志明市国际工业展会圆满结束",
        "展佳模具参展越南胡志明市国际工业展会",
      ],
      section1Title: "展会布局：",
      paragraph1: "展佳模架展位内，越南客户咨询并探讨了模架制造工艺及适用产品行业，与我司销售人员及技术人员深入交流。并探讨了模架定制流程及出口的可能性，为今后的合作做好铺垫工作。",
      section2Title: "展佳模架展会现场：",
      paragraph2: "展佳模架的技术人员及销售人员与越南客户充分交流，与越南胡志明市及河内市的中国企业以及日韩客户进一步接洽中，对于近期的国际经济形势下的越南市场计划进一步开拓。",
    },
    relation: {
      title: "联系我们",
      subtitle: "CONTACT US",
      companyName: "苏州市展佳模具有限公司",
      fields: [
        "办公地址：江苏省苏州市吴中区甪直镇长虹南路8号",
        "注册地址：江苏省苏州市吴中区甪直镇长虹南路8号",
        "官网：http://www.888zhanjia.com",
        "电话：86512-66021960/+86 13901541064",
        "传真：86512-66021962",
        "邮箱：888zhanjia@163.com",
      ],
      tableHeaders: {
        department: "部门",
        name: "名称",
        fax: "传真",
        phone: "电话",
      },
      tableData: [
        { department: "业务部", name: "王女士 Ms.Wang", fax: "86512-66021960-0", phone: "18915582406" },
        { department: "生产主管", name: "肖副总 General Xiao", fax: "86512-66021960-804", phone: "" },
        { department: "MB", name: "", fax: "", phone: "+86 15370010380" },
        { department: "工程部", name: "蒋工 Mr.Jiang", fax: "86512-66021960-805", phone: "" },
      ],
    },
    bottom: {
      titles: ["底部导航", "产品"],
      links: [
        ["网站首页", "产品中心", "塑胶模模架"],
        ["关于展佳", "新闻公告", "压铸模模架"],
        ["企业视频", "联系我们", ""],
      ],
      contactTitle: "联系我们",
      contactFields: [
        "办公地址：江苏省苏州市吴中区甪直镇长虹南路8号",
        "注册地址：江苏省苏州市吴中区甪直镇长虹南路8号",
        "官网：http://www.888zhanjia.com",
        "电话：86512-66021960/+86 13901541064",
        "传真：86512-66021962",
        "邮箱：888zhanjia@163.com",
        "备案：苏ICP备2024066295号",
      ],
    },
  },
  en: {
    home: {
      nav: ["Home", "About Zhanjia", "Corporate Video", "Product Center", "News", "Contact Us"],
      languageLabel: "中",
    },
    shared: {
      topTitles: {
        about: "About Us",
        video: "Corporate Video",
        product: "Product Center",
        news: "News",
        relation: "Contact Us",
      },
      tabView: ["Company Profile", "Contact Us", "News"],
    },
    formWork: {
      heroTitle: "Custom-Built with Precision Control",
      heroSubtitle: "CMM-verified accuracy, smooth mold base operation, and 50% longer service life",
      introLines: [
        "Since its establishment in April 2008,",
        "the company has relied on outstanding designers and skilled mold technicians to deliver high-quality products and earn strong customer recognition.",
        "The company has obtained ISO 9001 Quality Management System certification. Standardized management is helping us move onto a faster and more disciplined development track.",
        "We continue to win customer trust through reasonable pricing, advanced management, and dependable quality.",
      ],
      sectionTitle: "Zhanjia Mold Base",
      sectionSubtitle: "Professional mold base solutions for a wide range of mold applications",
      process: ["Customer Drawing Input", "Drawing Breakdown & Programming", "Material Customization", "Machining to Drawing", "Mold Base Assembly", "Qualified Delivery"],
      craftsmanshipTitle: "Craftsmanship Builds",
      craftsmanshipHighlight: "Premium Quality",
      craftsmanshipLines: [
        "Driven by our dedication to precision machining, Zhanjia has upheld",
        "the principles of reliable quality, customer priority, continuous innovation,",
        "and win-win cooperation since its founding. With multiple high-precision",
        "automated machining systems, we keep improving product and service quality",
        "to deliver outstanding solutions to the industry and advance with purpose.",
      ],
      categoryTitle: "Product Categories",
      categoryItems: ["Plastic Mold Bases", "Die-Casting Mold Bases"],
      productCards: [
        "Plastic & Cosmetic Mold Bases",
        "Die-Casting Mold Bases",
        "Plastic Molds",
        "Die-Casting Molds",
      ],
      viewMore: "VIEW MORE",
      strengthTitle: "Zhanjia Strength in Custom Manufacturing",
      strengthSubtitle: "Empowering high-quality development in Chinese manufacturing with premium mold bases",
      strengthYearSuffix: "Years",
      strengthLines: [
        "Focused on mold base customization for 15 years, we provide tailored process solutions and complete equipment support across automotive, home appliance, cosmetic,",
        "plastic, die-casting, and two-color mold base applications, earning broad customer trust.",
      ],
      serviceTitle: "Service Features",
      serviceSubtitle: "Service Features",
      serviceItems: [
        "Expert guidance: Professional mold base consultation and industrial solution support.",
        "One-stop sourcing: Reduce procurement cost and save valuable time.",
        "Quality assurance: Backed by ISO-certified quality management.",
        "A faithful practitioner of the philosophy of mutual growth and shared profitability.",
      ],
    },
    regard: {
      title: "Company Profile",
      subtitle: "COMPANY PROFILE",
      slogan: "Integrity in Business, Harmony in Cooperation",
      profileLines: [
        "We specialize in manufacturing custom mold bases for precision cosmetic molds, plastic molds, automotive molds, die-casting molds, and other non-standard mold applications. Since April 2008, we have earned customer recognition through skilled designers, experienced mold technicians, and consistently high product quality.",
        "Our facility is equipped with 20 CNC machining centers, gantry milling machines, and multiple large grinding, drilling, and milling machines. Our average monthly output reaches 200 mold base sets, mainly for non-standard requirements. Precision inspection is supported by CMM systems, electronic height gauges, bore gauges, and micrometers. Production equipment and inspection instruments sourced from Japan and Taiwan provide a solid foundation for our precision machining capability.",
        "Since implementing performance reform in early 2017, our production departments have adopted contract-based incentive systems, significantly increasing output by 40% over previous periods. We will continue expanding capacity and adding higher-precision equipment to meet the needs of customers across industries. Our long-term development plan targets high-precision die-casting molds, plastic molds, cosmetic molds, automotive molds, and home appliance molds. Through more standardized internal management, improved working conditions, and continuous skill development, we aim to elevate the company to a new stage of growth.",
      ],
      stats: [
        { value: "2008", unit: "", text: "Founded in 2008" },
        { value: "3000", unit: "m²+", text: "Factory, office, and staff dormitory area exceeds 3,000 square meters" },
        { value: "200", unit: "sets/month", text: "Average monthly mold base output reaches 200 sets" },
      ],
      purposeTitle: "Corporate Purpose",
      purposeSubtitle: "CORPORATE PURPOSE",
      purposes: [
        { title: "Quality First", text: "Create outstanding mold bases, lead the industry with superior quality, satisfy customer needs, and keep innovating." },
        { title: "Customer First", text: "Stay customer-centered, listen carefully, provide tailored solutions, and build a win-win future together." },
        { title: "Unity", text: "Emphasize teamwork, unlock employee potential, and create a harmonious, efficient workplace for shared growth." },
        { title: "Innovation-Driven", text: "Innovation powers mold base technology and drives us to keep setting new industry benchmarks." },
      ],
      spiritTitle: "Corporate Spirit / Core Values",
      spiritSubtitle: "CORPORATE SPIRIT / CORE VALUES",
      spirits: [
        { short: ["Resilience", "Responsibility"], text: "We build every mold base with resilience and responsibility. No matter the challenge, we remain accountable to our customers and to product quality. This mindset is the driving force behind our persistence and continuous improvement." },
        { short: ["Professional", "Focused"], text: "We stay focused within our field, continuously improve our technical capabilities, and pursue excellence. Our passionate professional team is committed to delivering high-level mold base solutions for diverse application needs." },
        { short: ["Innovative", "Progressive"], text: "Innovation is the spirit behind our continued progress. We encourage new ideas and foster a workplace culture that drives meaningful improvement and forward-looking mold base products." },
        { short: ["Efficient", "Standardized"], text: "We pursue excellence in both production and management through efficiency and standardized processes. Careful planning and strict quality control help us improve responsiveness while delivering reliable mold bases." },
        { short: ["Open", "Collaborative"], text: "We value openness and collaboration, growing together with customers, partners, and employees. By embracing external insight and close cooperation, we help advance the mold industry and create shared success." },
      ],
    },
    video: {
      title: "Video Center",
      subtitle: "VIDEO CENTER",
      slogan: "Integrity in Business, Harmony in Cooperation",
    },
    product: {
      title: "Product Center",
      subtitle: "PRODUCT CENTER",
      sections: [
        { title: "Die-Casting Molds", subtitle: "Die-Casting Mold" },
        { title: "Plastic Molds", subtitle: "Plastic Mold" },
      ],
    },
    news: {
      title: "News",
      subtitle: "NEWS",
      items: [
        {
          day: "26",
          date: "2023.10",
          title: "The three-day Russian International Machine Tool Exhibition concluded successfully on October 26, 2023, with strong customer engagement and excellent results.",
          summary: "At the Zhanjia Mold Base booth, Russian customers discussed mold base manufacturing processes, industry applications, and technical cooperation with our sales and engineering teams.",
        },
        {
          day: "18",
          date: "2023.11",
          title: "The Ho Chi Minh City International Industry Exhibition concluded successfully on November 18, 2023, with productive exchanges and solid business opportunities.",
          summary: "Zhanjia Mold Base held in-depth discussions with Vietnamese and international customers on mold base manufacturing processes, application sectors, and potential future cooperation.",
        },
      ],
      detailButton: "View Details",
    },
    newsDetails: {
      title: "Zhanjia Mold - Russian International Machine Tool Exhibition Successfully Concluded",
      outline: "[Summary]",
      date: "October 26, 2023",
      introLines: [
        "The three-day Russian International Machine Tool Exhibition concluded successfully.",
        "Zhanjia Mold participated in the Russian International Machine Tool Exhibition.",
        "Russian customers visited continuously, and the exhibition delivered fruitful results.",
      ],
      section1Title: "Highlights from the Zhanjia Mold Base booth:",
      paragraph1: "At the Zhanjia Mold Base booth, Russian customers consulted with our sales and technical staff on mold base manufacturing processes and target industry applications. We also discussed custom mold base workflows and export possibilities, laying a solid foundation for future cooperation.",
      paragraph2: "Russian customers highly recognized both the geographic and economic advantages of Suzhou, where Zhanjia Mold Base is located, as well as our product quality and processing capability. They expressed strong expectations for expanding Zhanjia Mold Base into the international market.",
      section2Title: "Acrylic samples displayed at the exhibition:",
      section3Title: "A corner of the booth:",
    },
    newsDetails2: {
      title: "Zhanjia Mold - Ho Chi Minh City International Industry Exhibition Successfully Concluded",
      outline: "[Summary]",
      date: "November 18, 2023",
      introLines: [
        "The three-day Ho Chi Minh City International Industry Exhibition concluded successfully.",
        "Zhanjia Mold participated in the Ho Chi Minh City International Industry Exhibition.",
      ],
      section1Title: "Exhibition layout:",
      paragraph1: "At the Zhanjia Mold Base booth, Vietnamese customers discussed mold base manufacturing processes and application sectors with our sales and technical teams. Both sides also explored customization workflows and export opportunities, creating favorable conditions for future cooperation.",
      section2Title: "On-site view of the Zhanjia Mold Base booth:",
      paragraph2: "Our technical and sales teams communicated extensively with Vietnamese customers and continued connecting with Chinese enterprises, as well as Japanese and Korean customers, in Ho Chi Minh City and Hanoi. We plan to further expand in the Vietnamese market under the current international economic environment.",
    },
    relation: {
      title: "Contact Us",
      subtitle: "CONTACT US",
      companyName: "Suzhou Zhanjia Mould Co., Ltd.",
      fields: [
        "Office Address: No. 8 Changhong South Road, Luzhi Town, Wuzhong District, Suzhou, Jiangsu, China",
        "Registered Address: No. 8 Changhong South Road, Luzhi Town, Wuzhong District, Suzhou, Jiangsu, China",
        "Website: http://www.888zhanjia.com",
        "Tel: 86512-66021960 / +86 13901541064",
        "Fax: 86512-66021962",
        "Email: 888zhanjia@163.com",
      ],
      tableHeaders: {
        department: "Department",
        name: "Contact",
        fax: "Fax",
        phone: "Phone",
      },
      tableData: [
        { department: "Sales", name: "Ms. Wang", fax: "86512-66021960-0", phone: "18915582406" },
        { department: "Production Supervisor", name: "Vice GM Xiao", fax: "86512-66021960-804", phone: "" },
        { department: "MB", name: "", fax: "", phone: "+86 15370010380" },
        { department: "Engineering", name: "Mr. Jiang", fax: "86512-66021960-805", phone: "" },
      ],
    },
    bottom: {
      titles: ["Footer Navigation", "Products"],
      links: [
        ["Home", "Product Center", "Plastic Mold Bases"],
        ["About Zhanjia", "News", "Die-Casting Mold Bases"],
        ["Corporate Video", "Contact Us", ""],
      ],
      contactTitle: "Contact Us",
      contactFields: [
        "Office Address: No. 8 Changhong South Road, Luzhi Town, Wuzhong District, Suzhou, Jiangsu, China",
        "Registered Address: No. 8 Changhong South Road, Luzhi Town, Wuzhong District, Suzhou, Jiangsu, China",
        "Website: http://www.888zhanjia.com",
        "Tel: 86512-66021960 / +86 13901541064",
        "Fax: 86512-66021962",
        "Email: 888zhanjia@163.com",
        "ICP Filing: Su ICP No. 2024066295",
      ],
    },
  },
};

export default siteText;
